import React from "react";
import { Link } from "react-router-dom";
import "./Welcome.css";

/* Landing page after a standalone /signup (free account). The /tips and
   /learn links are served by the Next content app, so they are plain <a>
   full loads; /treadmill and /membership stay in the CRA router. */
export default function Welcome() {
  return (
    <div className="Welcome">
      <div className="Welcome-card">
        <span className="Welcome-suits" aria-hidden="true">
          <span className="Welcome-suit Welcome-suit--s">&spades;</span>
          <span className="Welcome-suit Welcome-suit--h">&hearts;</span>
          <span className="Welcome-suit Welcome-suit--d">&diams;</span>
          <span className="Welcome-suit Welcome-suit--c">&clubs;</span>
        </span>
        <h1 className="Welcome-title">You&rsquo;re in.</h1>
        <ul className="Welcome-links">
          <li>
            <a href="/tips">Watch today&rsquo;s quick tips</a>
          </li>
          <li>
            <Link to="/treadmill">Start a Treadmill drill</Link>
          </li>
          <li>
            <a href="/learn?free=1">Read a free article</a>
          </li>
          <li>
            <a href="/learn/bidding/poland-2026-mixed-semi-final">Read the World Championships series</a>
          </li>
        </ul>
        <p className="Welcome-trial">
          Want all of it? <Link to="/membership">Start a 7-day free trial.</Link>
        </p>
      </div>
    </div>
  );
}
